<template>
    <div class="calculator" :class="{[settings?.type]:settings?.type, mini:mini}">

        <div :class="{collapsed: miniCollapsed}" v-if="mini">
            <div class="line">
                <div class="item">{{settings?.local?.youGet}}</div>
                <div class="value">{{calculatorValue?.toLocaleString()}} {{settings?.currency}}</div>
            </div>
            <vue-slider v-if="!miniCollapsed"
                v-model="calculatorValue"
                v-bind="options"
                @change="handeDrag"
                @dragging="handeDrag"
            />
            <div class="line highlight">
                <div class="item">{{settings?.local?.toBack}}</div>
                <div class="value">{{calculatorValue?.toLocaleString()}} {{settings?.currency}}</div>
            </div>
            <button v-if="miniCollapsed" class="more" @click.prevent="miniCollapsed = !miniCollapsed">{{settings?.local?.readMore}}</button>
            <button v-if="!miniCollapsed" class="submit mainButton" @click.prevent="miniCollapsed = !miniCollapsed">{{settings?.local?.save}}</button>
        </div>

        <div class="holder" v-else>
            <div class="topline">
                <div class="left">{{settings?.local?.sum}}</div>
                <div class="right">{{calculatorValue?.toLocaleString()}} {{settings?.currency}}</div>
            </div>
            <vue-slider
                v-model="calculatorValue"
                v-bind="options"
                @change="handeDrag"
                @dragging="handeDrag"
            />

            <div class="checkboxGroup">
                <div class="checkbox" v-for="(label, key) in settings?.local?.checkbox" :key="key">
                    <input type="checkbox" :id="key" :value="label" @change="saveToLocalStorage" v-model="selectedCheckboxes" />
                    <label :for="key">{{ label }}</label>
                </div>
            </div>

            <button v-if="settings.local" data-target="target_goal_get_money" :data-href="settings?.url" type="button" class="submit comeback" @click="saveToLocalStorage">
                {{settings.local.getMoney}} {{calculatorValue?.toLocaleString()}} {{settings.currency}}
            </button>

            <div class="bottomLine" v-if="settings.local" >
                <div class="left">{{settings.local?.back}}</div>
                <div class="right">
                    <div class="crossedOut">{{formattedSum()}}</div>
                    <div class="actual">{{calculatorValue.toLocaleString()}} {{settings?.currency}}</div>
                </div>
            </div>
        </div>

    </div>

</template>

<script setup>

import  VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import '@/assets/css/form.css';
import {onMounted, ref} from "vue";
import {ajax, setCookie, data} from "@/assets/js/Functions";


const props = defineProps({
    element: Object
});

const settings = ref({})
let options = {}

const selectedCheckboxes = ref([])
const calculatorValue = ref(0)

const mini = ref(data(props.element,'mini'))
const miniCollapsed = ref(true)

const formattedSum = () => {
    return (parseInt(calculatorValue.value * 1.06)).toLocaleString()
}

const handeDrag = (value) => {
    const firstLabel = document.querySelector('.vue-slider-marks .vue-slider-mark:first-child');
    const lastLabel = document.querySelector('.vue-slider-marks .vue-slider-mark:last-child');
    if(firstLabel) firstLabel.style.visibility = (value <= settings.value.min + 0.15 * (settings.value.max - settings.value.min)
        ? 'hidden' : 'visible')

    if(lastLabel) lastLabel.style.visibility = (value >= settings.value.max - 0.15 * (settings.value.max - settings.value.min)
        ? 'hidden' : 'visible')

    calculatorValue.value = value
    saveToLocalStorage()
}

// Инициализация значений из localStorage при создании компонента
onMounted(() => {
    const storedSelectedCheckboxes = localStorage.getItem('selectedCheckboxes');
    if (storedSelectedCheckboxes) {
        selectedCheckboxes.value = JSON.parse(storedSelectedCheckboxes);
    }

    const storedCalculatorValue = localStorage.getItem('calculatorValue');
    if (storedCalculatorValue) {
        calculatorValue.value = parseFloat(storedCalculatorValue);
    }
    ajax({
        action: "get_calculator_settings",
    }, (response) => {
        settings.value = response
        calculatorValue.value = localStorage.getItem('calculatorValue') ? parseInt(localStorage.getItem('calculatorValue')) : response.from
        options = {
            silent: true,
            dotSize: 38,
            width: 'auto',
            height: 6,
            duration: 0,
            disabled: false,
            marks: [response.min, response.max],
            min: response.min,
            max: response.max,
            interval: Number.isInteger((response.max - response.min) / response.step) ? response.step : 1,
            enableCross: true,
            hideCoveredLabels: true,
            dotOptions: {
                disabled: false,
                tooltip: 'none',
                style: {
                    background: '#fff url('+ response.caretImg +')',
                    backgroundSize: 'contain'
                }
            },
        }
    });
});

// Сохранение значений в localStorage при изменении переменных
const saveToLocalStorage = () => {
    setCookie('summ', calculatorValue.value, '365')
    localStorage.setItem('selectedCheckboxes', JSON.stringify(selectedCheckboxes.value));
    localStorage.setItem('calculatorValue', calculatorValue.value);
};
</script>

<style>
    .calculator{
        width: 525px;
        max-width: 100%;
        font-family: Montserrat;
        border-radius: 10px;
        background: #FFF;
        box-shadow: 0 0 14px 0 rgba(102, 111, 116, 0.20);
        padding: 30px;
        color: #333;
        user-select: none;
    }
    .caret{
        cursor: grabbing;
        border: none;
        padding: 0;
        border-radius: 50%;
        background-size: contain;
        filter: drop-shadow(0px 2px 5px rgba(44, 44, 44, 0.20));
        box-shadow: none;
        width: 100%;
        height: 100%;
    }
    .vue-slider-mark-label{
        color: #828282;
        text-align: right;
        font-size: 13px;
        font-style: normal;
        font-weight: 500;
        margin-top: 16px;
    }
    .vue-slider-marks .vue-slider-mark:first-child .vue-slider-mark-label{
        transform: none!important;
    }
    .vue-slider-marks .vue-slider-mark:last-child .vue-slider-mark-label{
        transform: translateX(-100%)!important;
    }
    .vue-slider-process {
        background-color: var(--color-primary);
    }
    .topline, .bottomLine {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
    }
    .topline{
        font-size: 20px;
        font-weight: 600;
    }
    .checkboxGroup{
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        margin: 30px 0;
    }
    .checkboxGroup .checkbox{
        display: flex;
    }
    .checkboxGroup .checkbox input{
        display: none;
    }
    .checkboxGroup .checkbox input + label{
        display: flex;
        align-items: center;
        font-size: 13px;
        color: #333;
        cursor: pointer;
        margin: 0;
    }
    .checkboxGroup .checkbox input + label:before{
        content: '';
        display: inline-block;
        width: 20px;
        height: 20px;
        background: #FFFFFF;
        border: 1px solid #333;
        border-radius: 4px;
        margin-right: 6px;
        transition: background-color ease-in-out 100ms;
    }
    .checkboxGroup .checkbox input:checked + label:before{
        background: var(--color-primary) url("data:image/svg+xml,%3Csvg width='11' height='10' viewBox='0 0 11 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10.5611 0.172381C11.0183 0.482293 11.1376 1.10411 10.8277 1.56124L5.74316 9.06124C5.57711 9.30618 5.3111 9.46499 5.01671 9.49496C4.72232 9.52493 4.42977 9.42297 4.21777 9.21652L0.302337 5.40362C-0.0933341 5.01831 -0.101734 4.3852 0.283575 3.98953C0.668885 3.59386 1.30199 3.58546 1.69766 3.97077L4.75771 6.95068L9.17228 0.438955C9.48219 -0.0181812 10.104 -0.13753 10.5611 0.172381Z' fill='white'/%3E%3C/svg%3E%0A") no-repeat center;
        background-size: auto;
        border-color: var(--color-primary);
    }
    .calculator button.submit{
        display: flex;
        min-height: 36px;
        padding: 14px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 6px;
        background: var(--secondary-orange, #F67B09);
        box-shadow: 0 6px 10px 0 rgba(246, 123, 9, 0.20);
        color: #fff;
        text-align: center;
        width: 100%;
        border: none;
        font-size: 16px;
        font-weight: 600;
        line-height: 120%;
        cursor: pointer;
        font-family: inherit;
        margin-bottom: 32px;
    }

    .bottomLine .right {
        display: flex;
        flex-wrap: wrap;
        gap: 14px;
        align-items: center;
        justify-content: center;
        color: var(--grayscale-gray-3, #828282);
        text-align: right;
        font-size: 16px;
        font-weight: 600;
    }
    .bottomLine .right .actual{
        color: var(--color-primary, #3EBF1F);
    }
    .bottomLine .right .crossedOut{
        text-decoration: line-through;
    }
    .bottomLine .right .left{
        color: var(--grayscale-gray-2, #4F4F4F);
        font-size: 16px;
        font-weight: 500;
    }
    .redirect{
        text-align: center;
        margin: 30px auto;
    }
    .redirect .title {
        font-size: 18px;
        font-weight: 600;
    }
    .redirect .loader{
        height: 20px;
        max-width: 350px;
        margin: 20px auto 5px;
        background: #ddd;
    }
    .redirect .loader span{
        display: block;
        height: inherit;
        width: 0;
        background: var(--color-primary);
    }
    .redirect .countdown {
        font-weight: 600;
        font-size: 14px;
        color: var(--color-primary);
    }
    .calculator button.mainButton{
        background: var(--color-primary);
        transition: background-color 300ms ease-in-out;
        box-shadow: none;
    }
    .calculator button.mainButton:hover{
        background: var(--color-primary-hover);
    }
    .calculator.mini{
        padding: 20px;
        border-radius: 10px;
        background: #FFF;
        color: #333;
        width: 100%;
    }
    .calculator.mini .line{
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        align-self: stretch;
        font-size: 16px;
    }
    .calculator.mini .collapsed .line:first-child{
        margin-bottom: 14px;
        padding-bottom: 14px;
        border-bottom: 1px solid #E0E0E0;
    }
    .calculator.mini .line.highlight{
        color: var(--color-primary);
        font-weight: 600;
        font-size: 14px;
        margin-bottom: 20px;
    }
    .calculator.mini :not(.collapsed) .line.highlight{
        margin-top: 34px;
    }
    .calculator.mini .more{
        color: #007EFF;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        padding: 0;
        text-decoration-line: underline;
        border: none;
        margin: 0;
    }
</style>